import { Provider } from "react-redux";
import { ThemeProvider } from "@mui/styles";
import { SnackbarProvider } from "notistack";
import { theme } from "styles/AtomicStyles";
import { initializeTracing } from "tracing";
import store from "utils/store";

import VersionManager from "components/VersionManager";

import Router from "./routes";

initializeTracing();

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <SnackbarProvider
          autoHideDuration={3000}
          anchorOrigin={{ horizontal: "left", vertical: "top" }}
        />
        <div data-testid="app" className="h-100">
          <VersionManager />
          <Router />
        </div>
      </Provider>
    </ThemeProvider>
  );
};

export default App;
